<template>
  <v-container>
    <h1>PAGE is Locked</h1>

    Locks expire in an hour.

  </v-container>
</template>

<script>
export default {
  name: 'PageLocked',
  props: ['title'],
  data: () => ({

  })
}
</script>
